import { REOPEN_EVALUATION_ASSESSMENT } from '../../../constants/api'
import errorHandler from '../errorHandler'
import { IEvaluationAssessorsUpdateRequest } from '../../../common/models/Evaluation'

export default (
  evaluationId: string,
  assessors: IEvaluationAssessorsUpdateRequest,
  token: string
) =>
  fetch(REOPEN_EVALUATION_ASSESSMENT(evaluationId), {
    method: 'PATCH',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(assessors),
  })
    .then(errorHandler)
    .then((e) => e)
